import React, { useState } from 'react';
import CheckIn from './CheckIn';
import ActionButton from 'componentsV2/AssestUpload/BulkUpload/ActionButton';
import { useDispatch, useSelector } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { assetUploadService } from 'api/assetUploadService';
import AlertBox from 'componentsV2/SharedAlertBox/AlertBox/AlertBox';
import { singleUploadActions } from 'actions/singleUpload';
import { useNavigate } from 'react-router';
import { HOME_PAGE } from 'constants/routes';
import { findElementByPrompt } from 'utils/utils';
import { UploadedFile } from '@komodo-design-system/komodo-core-web-components';
import AssetDetailContent from 'componentsV2/AssetDetailContent/AssetDetailContent';
interface AssetCheckInContentProps {
  assetDetails: any;
  assetId: string;
}

const AssetCheckInContent: React.FC<AssetCheckInContentProps> = ({
  assetDetails,
  assetId
}) => {
  const { userName } =
    useSelector((state: any) => state.userTypeReducer?.userType?.data) || {};
  const [responseAlert, setResponseAlert] = useState({
    isOpen: false,
    inputProps: { success: false },
    message: ''
  });
  const [checkIn, setCheckIn] = useState(false);
  const [files, setFiles] = useState<UploadedFile[]>([]);

  const singleUploadPayload = useSelector(
    (state: any) => state.singleUpload.payload
  );
  const navigate = useNavigate();
  const dispatch: ThunkDispatch<any, any, AnyAction> = useDispatch();

  const uploadFile = (event: CustomEvent<UploadedFile[]>) => {
    if (event.detail.length === 0) {
      return;
    }
    const detail = event.detail[0];
    const fileName = detail?.fileReference?.name;
    const name =
    findElementByPrompt(assetDetails, 'Name')?.value?.display_value ||
    'Asset Name Not Found';
    if (!fileName || fileName !== name) {
      setResponseAlert({
        isOpen: true,
        inputProps: { success: false },
        message: 'The filename and the format must be same as original file.'
      });
      setFiles([]);
      return;
    } 
    detail.status = 'completed';
    setFiles([detail]);
  };

  const handleCheckIn = () => {
    setCheckIn(!checkIn);
    setFiles([]); // Reset files when toggling check-in
  };

  const formattedSingleUploadPayload = () => {
    if (singleUploadPayload?.metadata_collection?.metadata_element_list) {
      singleUploadPayload.metadata_collection.metadata_element_list.forEach(
        (field: any) => {
          field.metadata_element_list.forEach((item: any) => {
            if(item.prompt === 'File Status'){
              item.value = { id: '2', display_value: 'Draft' }; // Update the value to New
            }
          });
        }
      );
    }
    const payload = JSON.parse(JSON.stringify(singleUploadPayload)); // Create a deep copy of the payload
    return payload;

  };

  const handleSubmit = async (event: any) => {
    event.preventDefault();
    try {
      // Assuming singleUploadPayload is the payload you want to submit
      dispatch({ type: 'LOADING SUCCESS', payload: true });
      const formData = new FormData();
      formData.append('payload', JSON.stringify(formattedSingleUploadPayload()));
      formData.append('file', files[0]?.fileReference || new Blob());
      const response = await assetUploadService
        .uploadAssets(formData, userName, assetId)
        .then((resp) => {
          return resp.json();
        });
      dispatch({ type: 'LOADING SUCCESS', payload: false });
      if (response?.asset_id?.length > 0) {
        setResponseAlert({
          isOpen: true,
          inputProps: { success: true },
          message:"Latest file uploaded successfully, Please publish it."
        });
      }
      if (response?.error || response?.detail) {
        setResponseAlert({
          isOpen: true,
          inputProps: { success: false },
          message:
            response?.message ||
            response?.detail ||
            'An error occurred while uploading the asset.'
        });
      }
    } catch (uploadError: any) {
      console.error('Error during asset upload:', uploadError);
      dispatch({ type: 'LOADING SUCCESS', payload: false });
      setResponseAlert({
        isOpen: true,
        inputProps: { success: false },
        message:
          uploadError?.message || 'An error occurred while uploading the asset.'
      });
    }
  };

  const handleClose = () => {
    if (responseAlert?.inputProps?.success) {
      dispatch(singleUploadActions.clearSingleUploadPayload());
      navigate(HOME_PAGE);
    }
    setResponseAlert({
      isOpen: false,
      inputProps: { success: false },
      message: ''
    });
  };

  return (
    <>
      <AssetDetailContent assetDetails={assetDetails} />
      <ActionButton submitCheckIn={handleCheckIn} isDisabled={false} />
      {checkIn && (
        <CheckIn
          files={files}
          setFiles={setFiles}
          uploadFile={uploadFile}
          handleSubmit={handleSubmit}
          handleCheckIn={handleCheckIn}
          assetDetails={assetDetails}
        ></CheckIn>
      )}
      {responseAlert?.isOpen && (
        <AlertBox
          message={responseAlert.message}
          isModalOpen
          handleClose={handleClose}
        />
      )}
    </>
  );
};

export default AssetCheckInContent;
